import React from 'react';

// keeping an empty CreateModal, will be removed as we will create separate modal for separate pages.
const CreateModal = () => {
  return <></>;
};

export default CreateModal;
